import { Fragment, useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import {
  GetPurchaseReceiveListData,
  SetPurchaseReceiveListData,
} from "../../store/purchaseReceiveAtom";
import { purchaseService } from "../../services/purchase.service";
import { Combobox, Transition } from "@headlessui/react";
import { CheckIcon, ChevronUpDownIcon } from "@heroicons/react/20/solid";

function PurchaseReceiveSearch() {
  const getPurchaseReceiveListData: any = GetPurchaseReceiveListData();
  const setPurchaseReceiveData = SetPurchaseReceiveListData();
  const [searchResult, setSearchResult] = useState([]);
  const [purchaseList, setPurchaseList] = useState([]);
  const [textInput, setTextInput] = useState("");
  const navigate = useNavigate();
  const mountedRef = useRef(true);

  const { pathname } = useLocation();
  var url = pathname.split("/");
  const currModuleId = url[1];
  const currModuleName = url[2];
  const currUserMenu = url[3];

  useEffect(() => {
    mountedRef.current = true;
    if (getPurchaseReceiveListData["Purchase_Receive_Info"]?.length > 0) {
      setPurchaseList(getPurchaseReceiveListData["Purchase_Receive_Info"]);
    } else {
      purchaseService.getPurchaseReceiveList().then((response) => {
        if (response?.data !== undefined) {
          setPurchaseReceiveData(response.data);
          setPurchaseList(response.data["Purchase_Receive_Info"]);
        }
      });
    }

    return () => {
      mountedRef.current = false;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);



  const processSearch = (search: string) => {
    setTextInput(search);

    if (search.length < 2) {
      setSearchResult([]);
    } else {
      purchaseService.searchPurchaseReceiveSearch(search).then((response) => {
        console.log("MNM ", response.data);
        if (response.data?.length) {
          setSearchResult(response.data);
        }
      });
    }
  };
  function selectedOption(purchase: any) {
    const { Purchase_Receive_Ref_No } = purchase;
    setSearchResult([]);
    setTextInput("");
    navigate(
      `/${currModuleId}/${currModuleName}/${currUserMenu}/details/${Purchase_Receive_Ref_No}`
    );
  }

  return (
    <>
      <Combobox>
        <div className="relative max-w-sm w-full">
          <div className="relative">
            <Combobox.Input
              className=" w-full rounded-full border font-medium border-gray-300 bg-white py-1.5 pl-10 pr-4 text-sm text-gray-800 placeholder-gray-400 focus:border-blue-600 focus:outline-none focus:ring-1 focus:ring-blue-600"
              // displayValue={(person) => person.name}
              placeholder="Search in Purchase Receive"
              onChange={event => processSearch(event.target.value)}
              // onChange={(event) => setTextInput(event.target.value)}
            />
            <Combobox.Button className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                strokeWidth={1.5}
                stroke="currentColor"
                className="size-5 text-gray-500"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="m21 21-5.197-5.197m0 0A7.5 7.5 0 1 0 5.196 5.196a7.5 7.5 0 0 0 10.607 10.607Z"
                />
              </svg>
            </Combobox.Button>
          </div>
          <Transition
            as={Fragment}
            leave="transition ease-in duration-100"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
            afterLeave={() => setTextInput('')}
          >
            <Combobox.Options className="absolute z-10 mt-2 max-h-60 w-full overflow-auto rounded-md bg-white py-1 text-sm shadow-lg ring-1 ring-black/10 focus:outline-none">
              {searchResult.length === 0 && textInput !== '' ? (
                <div className="relative cursor-default select-none  px-4 py-2 text-gray-700">Nothing found.</div>
              ) : (
                searchResult.map((invoice: any, i: number) => (
                  <Combobox.Option
                    key={i}
                    onClick={() => selectedOption(invoice)}
                    className={({ active }) =>
                      `relative cursor-pointer select-none text-xs font-medium py-2 pl-10 pr-4 ${
                        active ? 'bg-gray-100 text-white' : 'text-gray-700'
                      }`
                    }
                    value={invoice}
                  >
                    {({ selected, active }) => (
                      <>
                        <span className={` ${selected ? 'font-medium' : 'font-normal'}`}>
                          {invoice.Purchase_Receive_Number} |{invoice?.Purchase_Receive_Ref_No}
                        </span>
                        {selected ? (
                          <span className={`absolute inset-y-0 left-0 flex items-center pl-3 ${active ? 'text-white' : 'text-gray-700'}`}>
                            <CheckIcon className="h-5 w-5" aria-hidden="true" />
                          </span>
                        ) : null}
                      </>
                    )}
                  </Combobox.Option>
                ))
              )}
            </Combobox.Options>
          </Transition>
        </div>
      </Combobox>
    </>
  );
}

export default PurchaseReceiveSearch;
